module.exports = __webpack_public_path__ + "img/contact-us-icon.svg";